import { IGetZiplogInfoParams } from './GetZiplogInfoRequest';
import { Request } from './Request';

export interface IDeleteZiplogParams {
}

export interface IDeleteZiplogResult {
}

export class DeleteZiplogRequest extends Request<IDeleteZiplogParams, IDeleteZiplogResult> {
  constructor(params: IGetZiplogInfoParams = {}) {
    super('deleteZiplog', params);
  }
}
